<template>
  <div class="a_cus_wrap salebench_com">
      <!-- button -->
      <div class="btn">
        <el-button class="benchBtn benchBtnChecked" v-if="type=='common' && module.indexOf(',customer-index-apportion,')!=-1" size="mini" @click="reallocate">重新分配</el-button>
        <el-button class="benchBtn benchBtnChecked" v-if="type=='blacklist' && module.indexOf(',customer-index-rhei,')!=-1" size="mini" @click="renew">恢复</el-button>
      </div>
      <!-- table -->
      <el-table id="table" class="table" ref="multipleTable" border :data="customerData" v-loading = "isLoading" element-loading-background="rgba(0, 0, 0, 0.3)" element-loading-text="数据正在加载中" element-loading-spinner="el-icon-loading" stripe highlight-current-row size="mini" style="max-width: 100%;" height="100%" @selection-change="handleSelectionChange" @row-click="handleRowClick" @sort-change='sortThisColumn' :row-style="rowClass">
        <el-table-column type="selection" width="45" v-if="customerColumn.indexOf(',name,')!=-1"></el-table-column>
        <el-table-column prop="customer" label="客户名称" width="190" show-overflow-tooltip v-if="customerColumn.indexOf(',name,')!=-1">
          <template v-slot="scope">
            <span class="link" @click="lintToInfo(scope.row.id, scope.row.name)">{{scope.row.name}}</span><span class="hei" v-show="scope.row.is_hei==1" @click="showReason(scope.row)">黑</span>
          </template>
        </el-table-column>
        <el-table-column prop="linkman" label="联系人" v-if="customerColumn.indexOf(',linkman,')!=-1" show-overflow-tooltip width="100"></el-table-column>
        <el-table-column prop="phone" label="联系电话" v-if="customerColumn.indexOf(',phone,')!=-1" width="120"></el-table-column>
        <el-table-column prop="salesman_name" label="归属人" width="100" v-if="customerColumn.indexOf(',salesman_name,')!=-1"></el-table-column>
        <el-table-column prop="customer_attribute_name" label="客户属性" v-if="customerColumn.indexOf(',customer_attribute_name,')!=-1" width="100"></el-table-column>
        <el-table-column prop="customer_source_name" label="客户来源" v-if="customerColumn.indexOf(',customer_source_name,')!=-1" width="100"></el-table-column>
        <el-table-column prop="history_salesman_name" label="历史归属" v-if="customerColumn.indexOf(',history_salesman_name,')!=-1 && (type == 'common')" width="100" show-overflow-tooltip ></el-table-column>
        <el-table-column prop="contact_times" label="联系次数" width="100" sortable='custom' v-if="customerColumn.indexOf(',contact_times,')!=-1"></el-table-column>
        <el-table-column prop="visit_times" label="回访次数" v-if="customerColumn.indexOf(',visit_times,')!=-1" width="100" sortable="custom"></el-table-column>
        <el-table-column prop="sell_amount" label="历史成交(次数)" width="160" v-if="customerColumn.indexOf(',sell_count,')!=-1" show-overflow-tooltip sortable="custom">
          <template v-slot="scope">
            <span>{{scope.row.sell_square_sum == null ? 0 : scope.row.sell_square_sum}} m³ ({{scope.row.sell_count}}次)</span>
          </template>
        </el-table-column>
        <el-table-column prop="visit_time" label="上次回访日期" v-if="customerColumn.indexOf(',visit_time,')!=-1" width="120" sortable="custom" show-overflow-tooltip></el-table-column>
        <el-table-column prop="visit_content" label="上次回访内容" v-if="customerColumn.indexOf(',visit_content,')!=-1" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deal_time" label="上次交易时间" width="140" v-if="customerColumn.indexOf(',deal_time,')!=-1" show-overflow-tooltip sortable="custom"></el-table-column>
        <el-table-column prop="main_business" label="主营项目" v-if="customerColumn.indexOf(',main_business,')!=-1" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="breed" label="采购品类" v-if="customerColumn.indexOf(',breed,')!=-1" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" v-if="customerColumn.indexOf(',remark,')!=-1" min-width="200" show-overflow-tooltip></el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pag">
        <pagination v-if="refresh" ref="pagination" :lastpages.sync="pages.last_page" :currentpages.sync="pages.current_page" :all.sync="pages.total" :pagesizes.sync="pages.per_page" @getPage="getPage"></pagination>
      </div>
      <!-- 客户分配 -->
      <el-dialog v-dialog-drag title="重新分配" :visible.sync="reallocateDialog" width="300px" top="15%" class="reallocate"  @close="reAllocateClose">
        <el-form :model="reallocateForm" :inline="true">
          <el-form-item style="width: 100%; text-align: center;">
            <el-select v-model="reallocateForm.belong_id" placeholder="请选择销售人" size="mini">
                 <el-option v-for="item in salemanList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                
            </el-select>
          </el-form-item> 
        </el-form>
        <div slot="footer">
          <el-button class="benchBtn" @click="reallocateDialog = false">取消</el-button>
          <el-button type="primary" class="benchBtn benchBtnChecked" style="margin-right: 32px;" @click="allocateConfirm">保存</el-button>
        </div>
      </el-dialog> 
  </div>
</template>

<script>
import pagination from '../../../../components/pagination' 
export default {
  components: {
    pagination
  },
  props:{
    customerData: {
      type: Array,
      default: function(){
        return []
      }
    },
    pages: {
      type: Object,
      default: function(){
        return {
          last_page: 0,
          total: 0,
          current_page: 1,
          per_page: 20
        }
      }
    },
    customerColumn: {
      type: String,
      default: function(){
        return ''
      }
    },
    isLoading:{
      type:Boolean
    },
    type: String
  },
  data(){
    return {
      module:localStorage.dw_erp_power_code,
      tableData: [],
      multipleSelection: [],
      selectRow: [],
      selectData: [],
      showReturn: false,
      addBlackListDialog: false,
      addBlackListForm: {
        cause: ''
      },
      reallocateDialog: false,
      reallocateForm: {
        belong_id: ''
      },
      customerName: '',//公司名称
      customerID: 0, //公司ID      
      refresh: true,
      checked: false,
      salemanList: null
    } 
  },
  methods: {
    //排序
    sortThisColumn(column){
      if(column.prop == "contact_times" && column.order == "ascending"){
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "asc", column: "contact_times"})
        }else{
          this.$emit('sortBlackCustomer',{order: "asc", column: "contact_times"})
        } 
      }else if(column.prop == "contact_times" && column.order == "descending"){
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "desc", column: "contact_times"})
        }else{
          this.$emit('sortBlackCustomer',{order: "desc", column: "contact_times"})
        }  
      }else if(column.prop == "visit_times" && column.order == "ascending"){  
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "asc", column: "visit_times"})
        }else{
          this.$emit('sortBlackCustomer',{order: "asc", column: "visit_times"})
        }   
      }else if(column.prop == "visit_times" && column.order == "descending"){
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "desc", column: "visit_times"})
        }else{
          this.$emit('sortBlackCustomer',{order: "desc", column: "visit_times"})
        }
      }else if(column.prop == "visit_time" && column.order == "ascending"){
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "asc", column: "visit_time"})
        }else{
          this.$emit('sortBlackCustomer',{order: "asc", column: "visit_time"})
        } 
      }else if(column.prop == "visit_time" && column.order == "descending"){
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "desc", column: "visit_time"})
        }else{
          this.$emit('sortBlackCustomer',{order: "desc", column: "visit_time"})
        }  
      }else if(column.prop == "deal_time" && column.order == "ascending"){ 
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "asc", column: "deal_time"})
        }else{
          this.$emit('sortBlackCustomer',{order: "asc", column: "deal_time"})
        }         
      }else if(column.prop == "deal_time" && column.order == "descending"){
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "desc", column: "deal_time"})
        }else{
          this.$emit('sortBlackCustomer',{order: "desc", column: "deal_time"})
        }   
      }else if(column.prop == "sell_amount" && column.order == "ascending"){
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "asc", column: "sell_square_sum"})
        }else{
          this.$emit('sortBlackCustomer',{order: "asc", column: "sell_square_sum"})
        }  
      }else if(column.prop == "sell_amount" && column.order == "descending"){
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "desc", column: "sell_square_sum"})
        }else{
          this.$emit('sortBlackCustomer',{order: "desc", column: "sell_square_sum"})
        }  
      }else{
        if(this.type == 'common'){
          this.$emit('sortCommonCustomer',{order: "", column: ""})
        }else{
          this.$emit('sortBlackCustomer',{order: "", column: ""})
        }
        return
      }
    },
    //多选
    handleSelectionChange(val) {
      this.selectData=val
      this.multipleSelection=val
    },
    //分页
    getPage(obj){
      this.$emit('pageChangeEvent', obj)
    },
    //选中行添加样式
    rowClass({row,rowIndex}){
      if(this.selectRow.includes(row.id)){
        window.console.log(rowIndex)
        return {"background-color":'rgba(255, 235, 188, 0.75)'}     
      }
    },
    //行点击事件
    handleRowClick(row, column, event){
      if(column.label == '客户名称') return;
      this.$refs.multipleTable.toggleRowSelection(row);
      window.console.log(event)
    },
    //
    lintToInfo(id, name){
      localStorage.setItem("dw_erp_customer_id",id);
      localStorage.setItem("dw_erp_customer_name_workbench", name)
      this.$emit("parentHandle")
    },
    //恢复黑名单
    renew(){
      if(this.selectData.length == 0){
        this.tip("选择恢复客户",'warning')
        return
      }
      this.$confirm('恢复该黑名单客户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let arr = []
          let customer_id = ''
          this.multipleSelection.forEach(item=>{
            arr.push(item.id)
          })
          customer_id = arr.join(',')
          this.postFunc('erp/customer.index.rhei', {customer_id: customer_id}, ()=>{
            //刷新客户统计数据 黑名单数据
            this.$emit("refreshBacklist")
              this.$message({
                type: 'success',
                message: '恢复成功!'
              })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消恢复'
          })        
      })
    },
    //分配弹窗
    reallocate(){
       if(this.selectData.length == 0){
        this.tip('选择分配客户', 'warning');
        return
      } 
      this.reallocateDialog = true
      this.postFunc("erp/user.select",{},res=>{
        this.salemanList = res.data.data
      })
    },
    //分配弹窗关闭事件
    reAllocateClose(){
       this.reallocateForm.belong_id = ''
    },
    //分配确认
    allocateConfirm(){
      if(this.reallocateForm.belong_id == ''){
        this.tip("请选择销售人", 'warning')
        return
      }
      let arr = []
      let customer_id = ''
      this.multipleSelection.forEach(item=>{
        arr.push(item.id)
      })
      customer_id = arr.join(',')
      this.postFunc("erp/customer.index.apportion", {customer_id: customer_id, salesman_id: this.reallocateForm.belong_id}, ()=>{
        this.reallocateDialog = false 
        this.$emit('refreshPublic')
      })
    },
    //拉黑理由弹窗id
    showReason(row){
      let str = ''
      str = row.cause == '' ? '未填写拉黑原因' : row.cause
      this.$alert(str, '拉黑原因', {
        confirmButtonText: '关闭',
        callback: action => {
          window.console.log(action)
        }
      })
    }
  },
  watch: {
    selectData(data){
      this.selectRow = [];
      if(data.length>0){
        data.forEach(item=>{
          this.selectRow.push(item.id);
        })
      }
    },
    pages(){
      //强制刷新组件
      this.refresh= false
      this.$nextTick(()=>{
        this.refresh = true
      })
    }   
  },
}
</script>

<style scoped lang="scss">
.a_cus_wrap{
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: left;
  .table{
    flex: 1;
    margin-top: 5px;
    .link{
      color: #0099ff;
      cursor: pointer;
    }
    .link:hover{
      text-decoration: underline;
    }
    .hei{
        display: inline-block;
        width: 16px;
        height: 16px;
        line-height: 16px;
        border-radius: 50%;
        background: #333;
        color: #fff;
        font-size: 10px;
        text-align: center;
        margin-left: 3px;
        cursor: pointer;
    }
  }
  .pag{
    text-align: center;
    margin-bottom: 10px;
  }
}
.reallocate /deep/ .el-dialog__header{
    font-weight: 600;
}
.reallocate /deep/ .el-textarea__inner{
  border-color: #333;
  font-size: 12px;
}

.a_cus_wrap /deep/ .el-table th.gutter {display: table-cell !important;}
.a_cus_wrap /deep/ .el-table th.gutter{display: block !important;width: 28px !important;}
.a_cus_wrap /deep/ .el-tablecolgroup.gutter{display: block !important;width: 28px !important;}  
.a_cus_wrap /deep/ .el-table--border, .a_cus_wrap /deep/ .el-table--group {border: 1px solid #fff;}
.a_cus_wrap /deep/ .el-table--border th.gutter:last-of-type {border-bottom-color: #fff;border-top: 1px solid #ddd;position: relative;top: -1px;}
</style>